import React, { useEffect } from "react";
import { Paper } from "@mui/material";
import { cacheService, mediaService } from "../../../../../Core/Api/services";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { FileCategory } from "../../../../../Core/Api/Types/file-category";
import { FileStatus } from "../../../../../Core/Api/Types/file-status";
import TableSkeleton from "../../../../../Components/Table/TableSkeleton";
import { useAppSelector } from "../../../../../Redux/redux-store";
import { AssetSinglePreviewProps, PreviewContext } from "./asset-single-preview";
import { GetObject } from "../../../../../Redux/Reducers/redux-slice-asset";
import { GetPanelObject } from "../../../../../Redux/Reducers/redux-slice-drive";
import { useTranslation } from "react-i18next";
import "./asset-single-preview-docs.css";

interface AssetSinglePreviewDocsProps extends AssetSinglePreviewProps {
  url: string;
  blob: boolean;
  blobExt?: string;
}

function AssetSinglePreviewDocs(props: AssetSinglePreviewDocsProps) {
  const [fileUrl, setFileUrl] = React.useState("");
  const [fileName, setFileName] = React.useState("");
  const [fileExtension, setFileExtension] = React.useState("");
  const { context, url, blob, blobExt } = props;
  const asset = useAppSelector(
    context === PreviewContext.DriveFolderPreview || context === PreviewContext.DriveEnlarged
      ? GetPanelObject
      : GetObject
  );
  const id = asset?.id;

  useEffect(() => {
    console.log("AssetSinglePreviewDocs", id, url);
    if (id !== undefined && !blob)
      mediaService.GetFilesByObjectId(id).then((response) => {
        if (response.success !== null) {
          // Match online native file
          let match = response.files?.find((x) => x.category === FileCategory.Native && x.status === FileStatus.Online);

          if (match) {
            let url = `${mediaService.GetServiceUrl()}/media-infos/object/${id}/${
              match.id
            }/${cacheService.GetAuthKey()}`;

            setFileUrl(url);

            if (match.name) setFileName(match.name);
            if (match.extension) setFileExtension(match.extension);
          }
        }
      });
    else {
      setFileUrl(url!);

      if (blobExt) setFileExtension(blobExt);
    }
  }, [id]);

  return <DocPreviewer fileUrl={fileUrl} fileExtension={fileExtension} />;
}

export default AssetSinglePreviewDocs;

export const DocPreviewer = (props: { fileUrl: string; fileExtension: string }) => {
  const { t } = useTranslation();
  const { fileUrl, fileExtension } = props;

  return (
    <Paper
      sx={{
        backgroundImage: "none",
        minHeight: 500,
        maxHeight: 1000,
        height: "100%",
        overflow: "scroll",
      }}
    >
      {fileUrl !== "" && fileExtension !== ".pdf" && (
        <DocViewer
          pluginRenderers={DocViewerRenderers}
          documents={[{ uri: fileUrl }]}
          config={{
            header: {
              disableHeader: true,
              disableFileName: true,
              retainURLParams: false,
            },
          }}
          style={{ minHeight: 500, maxHeight: 1000 }}
        />
      )}
      {fileUrl !== "" && fileExtension === ".pdf" && (
        <object data={fileUrl} type="application/pdf" width="100%" height="100%">
          <iframe src={fileUrl} width="100%" height="100%">
            <p>
              {t("component:body.browserNotSupportPdfs")}
              <a href={fileUrl}>{t("button:downloadThePdf")}</a>.
            </p>
          </iframe>
        </object>
      )}
      {fileUrl === "" && <TableSkeleton />}
    </Paper>
  );
};
